import { FormikInput } from '../../../../common/forms';

/**
 * Username Input Component for Admin Login
 * Handles username field with validation
 */
function UsernameInput({ disabled = false, autoFocus = false }) {
    return (
        <FormikInput
            name="username"
            type="text"
            label="نام کاربری"
            placeholder="نام کاربری"
            disabled={disabled}
            required
            autoFocus={autoFocus} tooltip="نام کاربری را وارد کنید" />
    );
}

export default UsernameInput;
